export enum Env {
  Dev,
  Prod,
  Local,
  Test,
}
